import { Box, SxProps, Typography, useMediaQuery } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
import { theme } from '../../../theme/themeProvider';

const styles: IStyles = {
  card: {
    // height: { xs: pxToRem(78), md: 'max-content' },
    height: 'max-content',
    padding: {
      md: `${pxToRem(15)} ${pxToRem(15)} ${pxToRem(15)} ${pxToRem(15)}`,
    },
    width: { xs: '90vw', md: '25vw' },
    // backgroundColor: 'red',
    justifyContent: 'center',
    display: 'flex',
    // border: 'none',
    flexDirection: 'column',
  },

  chapterData: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  lessonsData: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    backgroundColor: '#FFF9E0',
    paddingX: { xs: pxToRem(10), md: pxTovW(14) },
    paddingY: { xs: pxToRem(5), md: pxTovW(7) },
    borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
    width: 'max-content',
  },
  resourcesData: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    backgroundColor: '#F4F0FF',
    paddingX: { xs: pxToRem(10), md: pxTovW(14) },
    paddingY: { xs: pxToRem(5), md: pxTovW(7) },
    borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
  },
};

interface IProps {
  image?: string;
  title?: string;
  subTitle?: string;
  headingData?: {
    yellowData?: { value: string; text: string };
    blueData?: { value: string; text: string };
  };
  rootStyle?: SxProps;
}

export const SubjectCard = (props: IProps) => {
  const { image, title, subTitle, headingData, rootStyle } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;

  let rootSx = { ...styles.card };
  if (rootStyle) rootSx = { ...rootSx, ...rootStyle };

  return (
    <Box sx={rootSx}>
      <Box sx={{ display: 'flex', gap: pxToRem(10) }}>
        <ImageWrapper
          name="ChapterImage1"
          type="png"
          parentFolder="tempAssets"
          styles={{
            height: { xs: pxToRem(60), md: pxTovW(154) },
            width: { xs: pxToRem(60), md: pxTovW(151) },
          }}
          path={image}
        />

        <Box
          sx={{
            display: 'flex',
            gap: { xs: pxToRem(3), md: pxTovW(13) },
            flexDirection: 'column',
          }}
        >
          <Typography variant="h1" fontWeight="bold">
            {title}
          </Typography>
          <Typography
            variant={isIpadOnly ? 'bodyText' : 'h4'}
            fontWeight="bold"
            color="primary"
          >
            {subTitle}
          </Typography>

          {headingData ? (
            <Box
              sx={{ display: 'flex', gap: { xs: pxToRem(10), md: pxTovW(10) } }}
            >
              {headingData.yellowData ? (
                <ExtraData
                  dataValue={headingData.yellowData.value}
                  dataText={headingData.yellowData.text}
                  backgroundColor={'#FFF9E0'}
                />
              ) : null}
              {headingData.blueData ? (
                <ExtraData
                  dataValue={headingData.blueData.value}
                  dataText={headingData.blueData.text}
                  backgroundColor={'#F4F0FF'}
                />
              ) : null}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

interface IExtraDataProps {
  dataValue: string;
  dataText: string;
  backgroundColor: string;
}
const ExtraData = (props: IExtraDataProps) => {
  const { dataValue, dataText, backgroundColor } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: pxToRem(10), md: pxTovW(10) },
        backgroundColor: backgroundColor,
        paddingX: { xs: pxToRem(10), md: pxTovW(14) },
        paddingY: { xs: pxToRem(5), md: pxTovW(7) },
        borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
      }}
    >
      <Typography
        variant="h3"
        color="neutral.royalBlue"
        fontWeight="bold"
        sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(25) } }}
      >
        {dataValue}
      </Typography>
      <Typography
        variant="h3"
        sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(21) } }}
      >
        {dataText}
      </Typography>
    </Box>
  );
};
